import axios from 'axios';
import store from '../../store/store'; // Import Redux Store


const baseURL = ''; // Podstawowy URL API

const ApiService = axios.create({  
  baseURL: baseURL, // Podstawowy URL API
  timeout: 5000, // Limit czasu na odpowiedÅº (5 sekund)
});

// Interceptor Å¼Ä…daÅ„ (np. dodawanie tokenÃ³w autoryzacyjnych)
ApiService.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.error('BÅ‚Ä…d w Å¼Ä…daniu:', error);
    return Promise.reject(error);
  }
);

ApiService.checkTokenExpiration = async () => {
  const state = store.getState();
  const { accessToken, refreshToken, accessTokenExpiration, refreshTokenExpiration } = state.tokens;

    // Aktualny czas w milisekundach
    const currentTime = Date.now();

    // Konwersja dat wygaÅ›niÄ™cia na milisekundy
    const accessTokenExpiresAtMs = new Date(accessTokenExpiration).getTime();
    const refreshTokenExpiresAtMs = new Date(refreshTokenExpiration).getTime();
    
  // Sprawdzenie, czy accessToken wygasÅ‚
  if (accessTokenExpiresAtMs && accessTokenExpiresAtMs < currentTime) {
    console.warn('Access token wygasÅ‚.');

    // Sprawdzenie, czy refreshToken jest waÅ¼ny
    if (refreshTokenExpiresAtMs && refreshTokenExpiresAtMs > currentTime) {
      console.log('OdÅ›wieÅ¼anie tokenu...');
      try {
        const newTokens = await ApiService.refreshTokens(refreshToken);
    
        return true; // Tokeny zostaÅ‚y odÅ›wieÅ¼one
      } catch (error) {
        console.error('BÅ‚Ä…d podczas odÅ›wieÅ¼ania tokenu:', error);
        alert('Sesja wygasÅ‚a. Zaloguj siÄ™ ponownie.');
        store.dispatch({ type: 'tokens/clearTokens' }); // Wyczyszczenie tokenÃ³w w Redux
        window.location.href = '/login'; // Przekierowanie na stronÄ™ logowania
        return false;
      }
    } else {
      console.warn('Refresh token rÃ³wnieÅ¼ wygasÅ‚. Wylogowywanie uÅ¼ytkownika...');
      alert('Sesja wygasÅ‚a. Zaloguj siÄ™ ponownie.');
      store.dispatch({ type: 'tokens/clearTokens' }); // Wyczyszczenie tokenÃ³w w Redux
      window.location.href = '/login'; // Przekierowanie na stronÄ™ logowania
      return false;
    }
  }

  console.log('Tokeny sÄ… waÅ¼ne.');
  return true; // Tokeny sÄ… waÅ¼ne
};

ApiService.refreshTokens = async (refreshToken) => {
  try {
    const response = await ApiService.get('/api/auth/access-token', {
      headers: {
        Authorization: `Bearer ${refreshToken}`, // Dodanie refreshToken do nagÅ‚Ã³wka
      },
    });

    const { token: accessToken, expiresAt: accessTokenExpiresAt } = response.data;

    // Zaktualizuj stan Redux
    store.dispatch({
      type: 'tokens/setAccessTokenWithExpiration',
      payload: {
        accessToken,        
        accessTokenExpiresAt,
      },
    });

    console.log('Token zostaÅ‚ odÅ›wieÅ¼ony.');
    return { accessToken, accessTokenExpiresAt };
  } catch (error) {
    console.error('BÅ‚Ä…d podczas odÅ›wieÅ¼ania tokenu:', error);
    throw error;
  }
};

// Interceptor Å¼Ä…daÅ„ (dodawanie tokenÃ³w autoryzacyjnych)
ApiService.getHeadersJsonUTF8OrDifferent = (contentType = 'application/json; charset=UTF-8') => {
  const token = store.getState().tokens.accessToken;

  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': contentType,
  };
};
ApiService.getHeaderOnlyToken = () => {
  const token = store.getState().tokens.accessToken;

  return {
    Authorization: `Bearer ${token}`,
  };
};


// Interceptor odpowiedzi (obsÅ‚uga bÅ‚Ä™dÃ³w)
ApiService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      const requestUrl = String(error?.config?.url || '');
      const isMediaRequest = requestUrl.startsWith('/attachment/') || requestUrl.startsWith('/images/');
      switch (status) {
        case 400:
          console.error('BÅ‚Ä…d 400: NieprawidÅ‚owe Å¼Ä…danie', data);
          alert('NieprawidÅ‚owe dane.');
          break;
        case 401:
          console.error('BÅ‚Ä…d 401: Nieautoryzowany', data);
          if (!isMediaRequest) {
            alert('Sesja wygasÅ‚a. Zaloguj siÄ™ ponownie.');
            store.dispatch({ type: 'tokens/clearTokens' }); // Wyczyszczenie tokenÃ³w w Redux
            window.location.href = '/login'; // Przekierowanie na stronÄ™ logowania
          }
          break;
        case 403:
          console.error('BÅ‚Ä…d 403: Brak dostÄ™pu', data);
          alert('Nie masz uprawnieÅ„ do wykonania tej operacji.');
          break;
        case 404:
          console.error('BÅ‚Ä…d 404: Nie znaleziono zasobu', data);
          alert('Nie znaleziono zasobu.');
          break;
        case 500:
          console.error('BÅ‚Ä…d 500: BÅ‚Ä…d serwera', data);
          alert('WystÄ…piÅ‚ bÅ‚Ä…d serwera. SprÃ³buj ponownie pÃ³Åºniej.');
          break;
        default:
          console.error(`BÅ‚Ä…d ${status}:`, data);
          alert('WystÄ…piÅ‚ nieoczekiwany bÅ‚Ä…d. SprÃ³buj ponownie.');
      }
    } else if (error.request) {
      console.error('Brak odpowiedzi z serwera:', error.request);
      alert('Nie moÅ¼na poÅ‚Ä…czyÄ‡ siÄ™ z serwerem. SprawdÅº swoje poÅ‚Ä…czenie internetowe.');
    } else {
      console.error('BÅ‚Ä…d:', error.message);
      alert('WystÄ…piÅ‚ bÅ‚Ä…d. SprÃ³buj ponownie.');
    }
    return Promise.reject(error);
  }
);

///-------------------------------------------------------------------------
// Funkcja logowania
ApiService.login = async (login, pass) => {
  try {
    const response = await ApiService.post('/api/auth/login', {
      login,
      pass,
    });
    return response.data; // ZwrÃ³Ä‡ dane odpowiedzi (np. tokeny)
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

///-------------------------------------------------------------------------
// users

ApiService.getUsers = async (sortBy, sortDirection, pageNumber, role, searchQuery) => {
    // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
    await ApiService.checkTokenExpiration();

  try {
    const payload = {
      ...(sortBy !== null && sortDirection !== null && { sortBy }),
      ...(sortBy !== null && sortDirection !== null && { sortDirection }),      
      ...(role !== null && { role }),
      ...(searchQuery !== null && { searchQuery }),
      pageNumber
    }
    const response = await ApiService.get('/api/admin/get-profiles', {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      params: payload,
      });
    return response.data; // ZwrÃ³Ä‡ dane uÅ¼ytkownikÃ³w
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

ApiService.changePasswordWithOld = async (oldPassword, newPassword) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.post('/api/password-recovery/password-change-with-old', {
            newPassword,
            oldPassword
        }, {
            headers: ApiService.getHeadersJsonUTF8OrDifferent(),
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

ApiService.getSportIcon = async (id) => {
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.get('/api/admin/sports/find-icon-by-id/' + id , {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
    });
    return response.data;
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

ApiService.getUserData = async (id) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/admin/profile/full_with_logins/' + id , {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
        });
        return response.data;
    } catch (error) {
        throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
    }
};

ApiService.getProfileById = async (userId) => {
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.get(`/api/profile/${userId}`, {
      headers: ApiService.getHeaderOnlyToken(),
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.getUserPayments = async (id) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/payments/history/' + id , {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
        });
        return response.data;
    } catch (error) {
        throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
    }
};

ApiService.getUserOpinions = async (id) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/opinion/partners/' + id , {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
        });
        return response.data;
    } catch (error) {
        throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
    }
};

ApiService.getUserOpinionsStats = async (id) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/opinion/partners/avg/' + id , {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
        });
        return response.data;
    } catch (error) {
        throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
    }
};

///-------------------------------------------------------------------------
// sports

ApiService.getSports = async (sortBy, sortDirection, keyword, pageNumber) => {
    // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
    await ApiService.checkTokenExpiration();
    
  try {
    const payload = {
      ...(sortBy !== null && sortDirection !== null && { sortBy }),
      ...(sortBy !== null && sortDirection !== null && { sortDirection }),
      ...(keyword && { keyword }),
      pageNumber
    }
    const response = await ApiService.get('/api/admin/sports/get-sports', {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      params: payload,
      });
    return response.data; // ZwrÃ³Ä‡ dane uÅ¼ytkownikÃ³w
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

ApiService.getTrainings = async (sortBy, sortDirection, keyword, pageNumber) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
  await ApiService.checkTokenExpiration();

  try {
    const payload = {
      ...(sortBy !== null && sortDirection !== null && { sortBy }),
      ...(sortBy !== null && sortDirection !== null && { sortDirection }),
      ...(keyword && { keyword }),
      pageNumber
    }
    const response = await ApiService.get('/api/admin/training', {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      params: payload,
    });
    return response.data; // ZwrÃ³Ä‡ dane uÅ¼ytkownikÃ³w
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

ApiService.getOpinionsU = async (sortBy, sortDirection, keyword, pageNumber) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
  await ApiService.checkTokenExpiration();

  try {
    const payload = {
      ...(sortBy !== null && sortDirection !== null && { sortBy }),
      ...(sortBy !== null && sortDirection !== null && { sortDirection }),
      // ...(keyword && { keyword }),
      pageNumber
    }
    const response = await ApiService.get('/api/opinion/partners', {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      params: payload,
    });
    return response.data; // ZwrÃ³Ä‡ dane uÅ¼ytkownikÃ³w
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

ApiService.getOpinionsT = async (sortBy, sortDirection, keyword, pageNumber) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
  await ApiService.checkTokenExpiration();

  try {
    const payload = {
      ...(sortBy !== null && sortDirection !== null && { sortBy }),
      ...(sortBy !== null && sortDirection !== null && { sortDirection }),
      // ...(keyword && { keyword }),
      pageNumber
    }
    const response = await ApiService.get('/api/opinion/trainings', {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      params: payload,
    });
    return response.data; // ZwrÃ³Ä‡ dane uÅ¼ytkownikÃ³w
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

ApiService.getNotResolvedUserReports = async (page, size) => {
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.get('/api/users-reports/not-resolved', {
      headers: ApiService.getHeaderOnlyToken(),
      params: {
        page,
        size,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.resolveUserReport = async (id) => {
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.put(`/api/users-reports/resolve/${id}`, {}, {
      headers: ApiService.getHeaderOnlyToken(),
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.getMessagesByIds = async (ids) => {
  await ApiService.checkTokenExpiration();

  try {
    const queryParams = new URLSearchParams();
    (ids || []).forEach((id) => queryParams.append('list', id));

    const response = await ApiService.get(`/api/communication/get-messages?${queryParams.toString()}`, {
      headers: ApiService.getHeaderOnlyToken(),
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.getChatMessagesByIds = async (ids) => {
  await ApiService.checkTokenExpiration();

  try {
    const queryParams = new URLSearchParams();
    (ids || []).forEach((id) => queryParams.append('list', id));

    const response = await ApiService.get(`/api/communication/get-chat-messages?${queryParams.toString()}`, {
      headers: ApiService.getHeaderOnlyToken(),
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.getProtectedAttachmentBlob = async (attachmentUrl) => {
  await ApiService.checkTokenExpiration();

  try {
    const rawUrl = String(attachmentUrl || '').trim();
    const attachmentIndex = rawUrl.indexOf('/attachment/');
    const imageIndex = rawUrl.indexOf('/images/');
    let relativeAttachmentUrl = '';

    if (attachmentIndex >= 0) {
      relativeAttachmentUrl = rawUrl.substring(attachmentIndex);
    } else if (imageIndex >= 0) {
      relativeAttachmentUrl = rawUrl.substring(imageIndex);
    } else if (rawUrl.startsWith('/attachment/') || rawUrl.startsWith('/images/')) {
      relativeAttachmentUrl = rawUrl;
    } else if (rawUrl) {
      relativeAttachmentUrl = `/attachment/${rawUrl}`;
    }

    if (!relativeAttachmentUrl) {
      throw new Error(`NieprawidÅ‚owy URL zaÅ‚Ä…cznika: ${attachmentUrl}`);
    }

    const response = await ApiService.get(relativeAttachmentUrl, {
      headers: {
        ...ApiService.getHeaderOnlyToken(),
        Accept: '*/*',
      },
      responseType: 'blob',
    });

    const rawContentType = String(response?.headers?.['content-type'] || '');
    const contentType = rawContentType.toLowerCase();
    if (contentType.includes('text/html')) {
      const sample = (await response.data.slice(0, 160).text()).trim().toLowerCase();
      if (sample.startsWith('<!doctype html') || sample.startsWith('<html')) {
        throw new Error(`Niepoprawna odpowiedÅº HTML dla zaÅ‚Ä…cznika pod adresem: ${relativeAttachmentUrl}`);
      }
    }

    const normalizedMimeType = rawContentType.split(';')[0].trim();
    if (normalizedMimeType) {
      return new Blob([response.data], { type: normalizedMimeType });
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.moveSportUp = async (sportOrder) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
  await ApiService.checkTokenExpiration();

const token =  store.getState().tokens.accessToken;
const path = `/api/admin/sports/order-move-up?order=${sportOrder}`;
try {
  const response = await ApiService.patch(path, {}, {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      });  
} catch (error) {
  throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
}
};

ApiService.moveSportDown = async (sportOrder) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
  await ApiService.checkTokenExpiration();

const token =  store.getState().tokens.accessToken;
const path = `/api/admin/sports/order-move-down?order=${sportOrder}`;
try {
  const response = await ApiService.patch(path, {}, {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka      
      });  
} catch (error) {
  throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
}
};

ApiService.addNewSport = async (sportData) => {
  await ApiService.checkTokenExpiration();
  
  try {
    const response = await ApiService.post('/api/admin/sports/add-new', sportData, {
      headers: ApiService.getHeadersJsonUTF8OrDifferent(),
      });
    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.geoCoding = async (longitude, latitude) => {
  await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get(`/api/resolve-location`, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
            params: {
                longitude,
                latitude
            }
        });

        return response.data; // ZwrÃ³Ä‡ dane odpowiedzi
    } catch (error) {
        throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
    }
}

ApiService.addNewUser = async (data) => {
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.post('/api/admin/register', data, {
      headers: ApiService.getHeadersJsonUTF8OrDifferent(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.getExcelReport = async (fromDate, toDate) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get(`/api/admin/activity/excel-report/${fromDate}/${toDate}`, {
            headers: ApiService.getHeaderOnlyToken(),
            responseType: 'blob', // WaÅ¼ne dla plikÃ³w Excel
            timeout: 300000
        });
        return response;
    } catch (error) {
        throw error;
    }
};


ApiService.toggleHasBlocked = async (userId) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.patch(`/api/admin/toggle-user-blocked/${userId}`, {}, {
            headers: ApiService.getHeadersJsonUTF8OrDifferent(),
        });
        return null;
    } catch (error) {
        throw error;
    }
};

ApiService.getHasBlocked = async (userId) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get(`/api/admin/user-has-blocked/${userId}`,{
            headers: ApiService.getHeadersJsonUTF8OrDifferent(),
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

ApiService.getSportById = async (sportId) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.get(`/api/admin/sports/find-by/id/${sportId}`, {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      });
    return response.data; // ZwrÃ³Ä‡ dane odpowiedzi
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
}
ApiService.toggleSportActive = async (sportId) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.patch(`/api/admin/sports/toggle-activation?id=${sportId}`, {}, {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka    
      });
    return response.data; // ZwrÃ³Ä‡ dane odpowiedzi
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
}
ApiService.updateSport = async (sportData) => {
  await ApiService.checkTokenExpiration();

  const token = store.getState().tokens.accessToken;

  try {
    const response = await ApiService.post(`/api/admin/sports/update`, sportData, {
      headers: ApiService.getHeadersJsonUTF8OrDifferent(), 
      });
    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.deleteUsersByIdList = async (idList) => {
  await ApiService.checkTokenExpiration();

  const token = store.getState().tokens.accessToken;

  try {
    const response = await ApiService.delete('/api/delete_accounts', {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: idList, // Lista ID w ciele zapytania
    });

    return response // ZwrÃ³Ä‡ odpowiedÅº serwera
  } catch (error) {
    throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
  }
};

ApiService.setSortListEndpoint = async (sort) => {
await ApiService.checkTokenExpiration();

  const token = store.getState().tokens.accessToken;

  try {
    const response = await ApiService.put('/api/admin/app_config/sport_sort_config/'+sort,{}, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },      
    });

    return response // ZwrÃ³Ä‡ odpowiedÅº serwera
  } catch (error) {
    throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
  }
};

ApiService.getSortListEndpoint = async () => {
await ApiService.checkTokenExpiration();

  const token = store.getState().tokens.accessToken;

  try {
    const response = await ApiService.get('/api/admin/app_config/sport_sort_config',
      {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      });
    return response.data // ZwrÃ³Ä‡ odpowiedÅº serwera
  } catch (error) {
    throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
  }
};

///-------------------------------------------------------------------------
// images
ApiService.uploadImage = async (file) => {
  // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne
  await ApiService.checkTokenExpiration();

  const token = store.getState().tokens.accessToken;
  const formData = new FormData();
  formData.append('file', file); // Dodanie pliku do formData

  try {
    const response = await ApiService.post('/api/admin/image-upload', formData, {
      headers: ApiService.getHeadersJsonUTF8OrDifferent('multipart/form-data'),
    });
    return response.data; // ZwrÃ³Ä‡ ciÄ…g znakÃ³w zwrÃ³cony przez endpoint
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};


///-------------------------------------------------------------------------
/// notifications

ApiService.getNotifications = async (sortBy, sortDirection, keyword, pageNumber) => {
    // Sprawdzenie waÅ¼noÅ›ci tokenÃ³w i odÅ›wieÅ¼enie, jeÅ›li to konieczne lub usuniecie danych o tokenach i przekierowanie na stronÄ™ logowania
    await ApiService.checkTokenExpiration();
    
  try {
    const payload = {
      ...(sortBy !== null && sortDirection !== null && { sortBy }),
      ...(sortBy !== null && sortDirection !== null && { sortDirection }),
      ...(keyword && { keyword }),
      pageNumber
    }
    const response = await ApiService.get('/api/admin/notifications', {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      params: payload,
      });
    return response.data; // ZwrÃ³Ä‡ dane uÅ¼ytkownikÃ³w
  } catch (error) {
    throw error; // ObsÅ‚uga bÅ‚Ä™dÃ³w jest juÅ¼ zaimplementowana w interceptorze
  }
};

ApiService.updateNotification = async (notificationData) => {
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.patch('/api/admin/notifications', notificationData, {
      headers: ApiService.getHeadersJsonUTF8OrDifferent(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.addNewNotification = async (notificationData) => {
  await ApiService.checkTokenExpiration();
  
  try {
    const response = await ApiService.post('/api/admin/notifications', notificationData, {
      headers: ApiService.getHeadersJsonUTF8OrDifferent(),
      });
    return response.data;
  } catch (error) {
    throw error;
  }
};

ApiService.deleteNotifByIdList = async (idList) => {
  await ApiService.checkTokenExpiration();

  const token = store.getState().tokens.accessToken;

  try {
    const response = await ApiService.delete('/api/admin/notifications', {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: idList, // Lista ID w ciele zapytania
    });

    return response // ZwrÃ³Ä‡ odpowiedÅº serwera
  } catch (error) {
    throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
  }
};

ApiService.getNotificationTypes = async () => {
await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.get('/api/admin/notifications/types',
      {
      headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
      });
    return response.data // ZwrÃ³Ä‡ odpowiedÅº serwera
  } catch (error) {
    throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
  }
};

ApiService.getStatistics = async () => {
  await ApiService.checkTokenExpiration();

  try {
    const response = await ApiService.get('/api/admin/activity',
        {
          headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
        });
    return response.data // ZwrÃ³Ä‡ odpowiedÅº serwera
  } catch (error) {
    throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
  }
};

ApiService.getFaq = async () => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/faq/by-admin',
            {
                headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagÅ‚Ã³wka
            });
        return response.data // ZwrÃ³Ä‡ odpowiedÅº serwera
    } catch (error) {
        throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
    }
};

ApiService.addNewFaq = async (data) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.post('/api/faq', data, {
            headers: ApiService.getHeadersJsonUTF8OrDifferent(),
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

ApiService.deleteFaq = async (id) => {
    await ApiService.checkTokenExpiration();

    const token = store.getState().tokens.accessToken;

    try {
        const response = await ApiService.delete('/api/faq/' + id , {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        });

        return response // ZwrÃ³Ä‡ odpowiedÅº serwera
    } catch (error) {
        throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
    }
};



ApiService.getChartStats = async (scope) => {
    await ApiService.checkTokenExpiration();

    const paths = {
        monthly: '/api/admin/activity/chart/monthly',
        yearly: '/api/admin/activity/chart/yearly',
        weekly: '/api/admin/activity/chart/weekly',
    }

    var scopePath = paths[scope];

    try {
        const response = await ApiService.get(scopePath,
            {
                headers: ApiService.getHeadersJsonUTF8OrDifferent(), // Dodanie tokenu do nagÅ‚Ã³wka
            });
        return response.data // ZwrÃ³Ä‡ odpowiedÅº serwera
    } catch (error) {
        throw error; // ObsÅ‚uÅ¼ bÅ‚Ä™dy w miejscu wywoÅ‚ania
    }
};


export default ApiService;

